import { render, staticRenderFns } from "./Bureau.vue?vue&type=template&id=6bfcd526"
import script from "./Bureau.vue?vue&type=script&lang=js"
export * from "./Bureau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports